/**
 * Merge two queries
 * @param initialQuery
 * @param queryStored
 * @returns {Object}
 */
const mergeQuery = (initialQuery = {}, queryStored = {}) => {
    const filtersMap = new Map();

    [...(initialQuery?.filters || []), ...(queryStored?.filters || [])].forEach(filter => {

        if (!filter || filter.key === undefined || filter.key === null) {
            return;
        }

        // Avoid filters duplication by key
        filtersMap.set(filter.key, filter);
    });

    return {
        ...initialQuery,
        ...queryStored,
        filters: Array.from(filtersMap.values())
    };
};

export default mergeQuery;